import packageInfo from '../../package.json';

export const environment = {
    production: true,
    apiUrl: 'https://api.vestra-app.com',
    allowedDomains: 'api.vestra-app.com',
    version: packageInfo.version,
};
